import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type GoalModel from 'scaleflow/models/goal';
import type MetricModel from 'scaleflow/models/metric';

interface GoalsMetricsSignature {
  Args: {
    goal: GoalModel;
  };
  Blocks: {
    default: [];
  };
  Element: null;
}

export default class GoalsMetricsComponent extends Component<GoalsMetricsSignature> {
  @tracked metricWizardIsVisible = false;
  @tracked selectedMetric: MetricModel | null = null;
  @tracked selectedTargets: unknown[] = [];

  @action
  openMetricWizard() {
    this.metricWizardIsVisible = true;
  }

  @action
  closeMetricWizard() {
    this.metricWizardIsVisible = false;
  }

  @action
  openChartModal(metric: MetricModel) {
    this.selectedMetric = metric;

    const metricModel = (metric as any)?.content ?? metric;
    this.selectedTargets = metricModel?.targets?.content ?? [];
  }

  @action
  closeChartModal() {
    this.selectedMetric = null;
    this.selectedTargets = [];
  }

  @action
  unlinkMetric(metric: MetricModel) {
    const targets = this.args.goal.targets?.content;
    const target = targets?.find(
      (_target: any) => _target.metric?.content?.id === (metric as any).id,
    );
    void target?.destroyRecord();
    this.closeChartModal();
  }
}
